import React from 'react';
import { darken } from 'polished';
import styled, { useTheme } from 'styled-components';
import scrollTo from 'gatsby-plugin-smoothscroll';

import { Anchor, Button, Flex, Text } from '../../../components/blocks';

import OnlineView from '../../../images/icon/online-view.svg';
import Mail from '../../../images/icon/mail.svg';

type Props = {
  green?: boolean;
  fill?: boolean;
  inquirytitle?: string;
  onlinetitle?: string;
};

const Explanation = styled.div<{ green?: boolean }>`
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  top: -12px;
  width: fit-content;
  padding: ${({ theme }) => `${theme.spaces.xs} ${theme.spaces.l}`};
  background-color: ${({ theme, green }) =>
    green
      ? darken(0.08, theme.backgroundColors.green)
      : darken(0.15, theme.fontColors.yellow)};
  font-size: ${({ theme }) => theme.fontSizes.s};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  color: ${({ theme, green }) =>
    green ? theme.fontColors.white : theme.fontColors.white};
  border-radius: ${({ theme }) => theme.radii.rounded};
  box-shadow: ${({ theme, green }) =>
    green ? theme.boxShadow.base : theme.boxShadow.base};

  :after {
    position: absolute;
    bottom: -16px;
    content: '';
    border: 8px solid transparent;
    border-top: 8px solid
      ${({ theme, green }) =>
        green
          ? darken(0.08, theme.backgroundColors.green)
          : darken(0.15, theme.fontColors.yellow)};
  }
`;

const Root = styled.div<{ fill?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spaces.xl};
  width: ${({ fill }) => (fill ? '100%' : 'auto')};
`;

export const CVButton: React.FC<Props> = (props) => {
  const theme = useTheme();

  return (
    <Root fill={props.fill}>
      <Anchor
        wide="l"
        color="green"
        id="productInquiryButton"
        fill
        radius="rounded"
        shadow="nav"
        to="#inquiry"
        // onClick={() => scrollTo('#inquiry')}
      >
        <Explanation green>
          {props.inquirytitle ? props.inquirytitle : '3分でDentisがわかる'}
        </Explanation>
        <Flex gap={theme.spaces.s}>
          <Mail width="24px" height="24px" alt="ダウンロード" />
          <Text as="span" size="xl" fontWeight="bold" color="white">
            資料請求・お問い合わせ
          </Text>
        </Flex>
      </Anchor>
      <Anchor
        wide="l"
        color="yellow"
        id="productDemoButton"
        fill
        radius="rounded"
        shadow="nav"
        to="/form/demo"
      >
        <Explanation>
          {props.onlinetitle ? props.onlinetitle : 'オンラインデモ実施中'}
        </Explanation>
        <Flex gap={theme.spaces.s}>
          <OnlineView width="24px" height="24px" alt="ダウンロード" />
          <Text as="span" size="xl" fontWeight="bold" color="brown">
            無料オンラインデモ
          </Text>
        </Flex>
      </Anchor>
    </Root>
  );
};
